export type OrderFinanceReadModelRefresh = () => Promise<unknown> | unknown;

export interface OrderFinanceReadModelRefreshers {
  order: OrderFinanceReadModelRefresh;
  marginHistory: OrderFinanceReadModelRefresh;
  settlementLedger: OrderFinanceReadModelRefresh;
}

/** One refresh seam for every read model affected by order finance writes. */
export async function refreshOrderFinanceReadModels(
  refreshers: OrderFinanceReadModelRefreshers,
): Promise<void> {
  await Promise.all([
    refreshers.order(),
    refreshers.marginHistory(),
    refreshers.settlementLedger(),
  ]);
}

/** A successful finance mutation is not complete until canonical reads refetch. */
export async function runOrderFinanceMutation<T>(
  mutate: () => Promise<T>,
  refresh: OrderFinanceReadModelRefresh,
): Promise<T> {
  const result = await mutate();
  await refresh();
  return result;
}
